import { createSlice } from '@reduxjs/toolkit';

import { getImpactStatsPublic } from '@/domain/impact-stats/actions/get-impact-stats-public.action';
import {
  EMPTY_IMPACT_STATS_PUBLIC,
  ImpactCo2AnswerStatsPublic,
} from '@/domain/impact-stats/entities/stats-public.entity';

export type ImpactStatsState = {
  public?: ImpactCo2AnswerStatsPublic;
};

const initialState: ImpactStatsState = {
  public: EMPTY_IMPACT_STATS_PUBLIC,
};

export const impactStatsSlice = createSlice({
  name: 'impactStats',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getImpactStatsPublic.fulfilled, (state, action) => {
      state.public = action.payload;
    });
  },
});
